module.exports = "/_next/static/images/WhatIsCustomerData@2x-38f1a3277c8e76a62495d2c14790d52c.png";